import React, { memo } from 'react'

import { useShallowEqualSelector } from 'custom-hooks'
import { getEquipmentFacilityIdSelector } from 'redux/reducers/equipments'
import { getLocationByIdSelector } from 'redux/reducers/profile'
import Title from 'components/CommonUI/Title/Title'
import LogoGroup from 'components/LogoGroup/LogoGroup'

const LogoSection = () => {
  const facilityId = useShallowEqualSelector(getEquipmentFacilityIdSelector)

  const {
    image_uri,
    name = '',
    group,
  } = useShallowEqualSelector(getLocationByIdSelector(facilityId))

  const [first, last] = group?.name?.split(' ') || []

  const alt = `${first && first[0]}${(last && last[0]) || ''}`.toUpperCase()

  return (
    <div className="header_logo_section">
      <LogoGroup
        classNameContainer="logo"
        alt="facyliti logo"
        src={image_uri}
        alternative={alt}
      />
      <div className="facility_info">
        <Title title="Equipment" component="h1" className="facility_title" />
        <span className="facility_name">{name}</span>
      </div>
    </div>
  )
}

export default memo(LogoSection)
